import { createAsyncThunk } from "@reduxjs/toolkit";
import { notificationFail, notificationSuccess } from "../slices/notificationSlice";
import { API, graphqlOperation } from 'aws-amplify';
import { categoryList, setCateLoader } from "../slices/categorySubstanceSlice";
import { deleteCategoryQuery, getCategoryListQuery, getSubstanceConfig } from "../../graphql/queries";
import { createNewCategory, createNewSubstance, changeCategorySubstance, addSubstanceConfig, updateSubstanceConfig, deleteSubstanceConfig, setDefaultOrder, addNewSubstanceConfig, createNewMasterCategory } from "../../graphql/mutations";
import { setLoader, substanceConfigurationList } from "../slices/substanceSlice";
import { ChangeServiceRequest } from "./commonThunk";
import { devApi, prodApi, qaApi } from "../../aws-export";
import { RootState } from "../store";

export const getCategoryList = createAsyncThunk("getCategoryList", async (_request: any, { dispatch }) => {
    try {
        dispatch(setCateLoader(true))
        const list = await API.graphql({
            ...graphqlOperation(getCategoryListQuery, { tenantCode: _request.request.tenantCode }),
            authMode: "AMAZON_COGNITO_USER_POOLS",
        }) as { data: any, errors: any[] };

        if (list.data && list.data.getCategory) {
            dispatch(categoryList(list?.data?.getCategory?.sort((a: any, b: any) => (parseInt(a?.order_number || 0) > parseInt(b?.order_number || 0) ? 1 : -1))));
        }
        dispatch(setCateLoader(false));
        if (_request.callback) {
            _request.callback()
        }
    } catch (err: any) {
        dispatch(notificationFail("Something went wrong"));
    }

});
export const deleteCategoryThunk = createAsyncThunk("deleteCategory", async (_request: any, { dispatch, getState }) => {
    try {
        const substanceConfigurationListData = (getState() as RootState)?.substanceSlice?.substanceConfigurationList || []
        const cateRequest = {
            pk: _request.request.pk,
            sk: _request.request.sk
        }
        dispatch(setCateLoader(true))
        const deleteResponse = await API.graphql({
            ...graphqlOperation(deleteCategoryQuery, { categorytDelete: cateRequest }),
            authMode: "AMAZON_COGNITO_USER_POOLS",
        }) as { data: any, errors: any[] };
        if (deleteResponse.data && deleteResponse.data.deleteCategory) {
            dispatch(notificationSuccess("Category Deleted successfully"));
            dispatch(getCategoryList({ request: { tenantCode: _request.request.pk } }));
            const substanceFilter = substanceConfigurationListData?.map((value: any) => {
                if (value?.category_id === _request.request.sk) {
                    return {
                        ...value,
                        category_id: null
                    }
                }
                return value;
            })
            dispatch(substanceConfigurationList(substanceFilter));
        }
        dispatch(setCateLoader(false));
        if (_request.callback) {
            _request.callback()
        }
    } catch (err: any) {
        console.log(err);
        dispatch(setCateLoader(false));
        dispatch(notificationFail("Something went wrong"));
    }
});

export const addNewCategory = createAsyncThunk("addNewCategory", async (_request: any, { dispatch }) => {
    try {
        dispatch(setCateLoader(true))
        const resp = await API.graphql({
            ...graphqlOperation(createNewCategory, { addCategory: _request.request }),
            authMode: "AMAZON_COGNITO_USER_POOLS",
        }) as { data: any, errors: any[] };
        if (resp.data.addCategory.success === 'true') {
            if (!!_request.request.pk) {
                dispatch(notificationSuccess("Category Update Successfully"));
            } else {
                dispatch(notificationSuccess("Category Added Successfully"));
            }
            if (_request.callback) {
                _request.callback()
            }
            const request = {
                tenantCode: _request.request.tenantCode
            }
            dispatch(
                getSubstabceConfiguration({
                    tenantCode:_request.request.tenantCode,
                    isDelete: true,
                })
            );
            dispatch(getCategoryList({ request: request }));
           
        } else {
            dispatch(notificationFail("Category is already exists."));
        }
        dispatch(setCateLoader(false))
    } catch (error) {
        console.log("Error Log", error)
    }
});

export const addNewMasterCategory = createAsyncThunk("addNewMasterCategory", async (_request: any, { dispatch }) => {
    try {
        dispatch(setCateLoader(true))
        const resp = await API.graphql({
            ...graphqlOperation(createNewMasterCategory, { addCategoryMaster: _request.request }),
            authMode: "AMAZON_COGNITO_USER_POOLS",
        }) as { data: any, errors: any[] };
        console.log("resprespresp",resp);        
        if (resp.data.addCategoryMaster.success === 'true') {
            if (!!_request.request.pk) {
                dispatch(notificationSuccess("Category Update Successfully"));
            } else {
                dispatch(notificationSuccess("Category Added Successfully"));
            }
            if (_request.callback) {
                _request.callback()
            }
            const request = {
                tenantCode: _request.request.tenantCode
            }            
            dispatch(getCategoryList({ request: request }));           
        } else {
            dispatch(notificationFail("Category is already exists."));
        }
        dispatch(setCateLoader(false))
    } catch (error) {
        console.log("Error Log", error)
    }
});

export const addNewSubstance = createAsyncThunk("addNewSubstance", async (_request: any, { dispatch }) => {

    dispatch(setCateLoader(true))
    const resp = await API.graphql({
        ...graphqlOperation(createNewSubstance, { addSubstance: _request.request }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as { data: any, errors: any[] };
    if (resp.data.addSubstance.success === 'true') {
        dispatch(notificationSuccess("Characteristic Added Successfully"));
        dispatch(getCategoryList({}))
    } else {
        dispatch(notificationFail("Characteristic is already exists."));
    }
    dispatch(setCateLoader(false))
    if (_request.callback) {
        _request.callback()
    }
});

export const changeSubstanceCategory = createAsyncThunk("changeSubstanceCategory", async (_request: any, { dispatch }) => {

    dispatch(setCateLoader(true))
    const resp = await API.graphql({
        ...graphqlOperation(changeCategorySubstance, { changeCategorySubstance: _request.request }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as { data: any, errors: any[] };
    if (resp.data.changeCategorySubstance.success === 'true') {
    } else {
        dispatch(notificationFail("Opps! Something is wrong!"));
    }
    dispatch(setCateLoader(false))
    if (_request.callback) {
        _request.callback()
    }
});

export const addSubstabceConfiguration = createAsyncThunk("addSubstabceConfiguration", async (_request: any, { dispatch }) => {
    const resp = await API.graphql({
        ...graphqlOperation(addSubstanceConfig, { addSubstanceConfiguration: { substanceConfig: _request.request } }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as { data: any, errors: any[] };
    if (resp.data.addSubstanceConfiguration.success === 'true') {
    } else {
        dispatch(notificationFail("Configuration Not Set"));
    }
    if (_request.callback) {
        _request.callback()
    }
});
export const addNewSubstabceConfiguration = createAsyncThunk("addNewSubstabceConfiguration", async (_request: any, { dispatch }) => {
    const resp = await API.graphql({
        ...graphqlOperation(addNewSubstanceConfig, { addNewSubstanceConfiguration: _request.request }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as { data: any, errors: any[] };

    if (resp.data.addNewSubstanceConfiguration.success === 'true') {
    } else {
        dispatch(notificationFail(resp.data.addNewSubstanceConfiguration.message));
    }
    if (_request.callback) {
        _request.callback()
    }
});

export const getSubstabceConfiguration = createAsyncThunk(
    "getSubstabceConfiguration",
    async (_request: any, { dispatch }) => {
        const loginwithtype = localStorage.getItem("loginwith") || "";
        const serviceRequest =
            loginwithtype === "qa"
                ? qaApi
                : loginwithtype === "prod"
                    ? prodApi
                    : devApi;

        try {
            dispatch(ChangeServiceRequest({ request: serviceRequest }));

            const resp = await API.graphql({
                ...graphqlOperation(getSubstanceConfig, {
                    tenantCode: _request.tenantCode,
                    isDelete: _request.isDelete
                }),
                authMode: "AMAZON_COGNITO_USER_POOLS",
            }) as { data: any, errors: any[] };

            console.log("resprespresp",resp);
                        
            if (resp.data?.getSubstanceConfiguration) {
                dispatch(substanceConfigurationList(resp.data.getSubstanceConfiguration));
            }
            return resp.data?.getSubstanceConfiguration;
        } catch (error) {
            console.error("Error fetching Characteristics configuration:", error);
            throw error;
        }
    }
);


export const updateSubstabceConfiguration = createAsyncThunk("updateSubstabceConfiguration", async (_request: any, { dispatch }) => {
    try {
        dispatch(setCateLoader(true))
        const resp = await API.graphql({
            ...graphqlOperation(updateSubstanceConfig, { updateSubstanceConfiguration: _request.request }),
            authMode: "AMAZON_COGNITO_USER_POOLS",
        }) as { data: any, errors: any[] };
        dispatch(setCateLoader(false))
        if (resp.data.updateSubstanceConfiguration.success == 'true') {
            dispatch(notificationSuccess("Tile saved Successfully."));
        } else {
            dispatch(notificationFail("Tile Name Not Update"));
        }
    } catch (err) {
        console.log(err)
        dispatch(setCateLoader(false));
        dispatch(notificationFail("Tile Name Not Update"));

    }
});
export const deleteSubstabceConfiguration = createAsyncThunk("updateSubstabceConfiguration", async (_request: any, { dispatch }) => {
    const resp = await API.graphql({
        ...graphqlOperation(deleteSubstanceConfig, { deleteSubstanceConfiguration: _request.request }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as { data: any, errors: any[] };
    if (resp.data.deleteSubstanceConfiguration.success == 'true') {
    } else {
        dispatch(notificationFail("Tile is Not Delete"));
    }
});
export const setDefaultOrderAllTiles = createAsyncThunk("setDefaultOrderAllTiles", async (_request: any, { dispatch }) => {
    const resp = await API.graphql({
        ...graphqlOperation(setDefaultOrder, { tenantCode: _request.tenantCode }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as { data: any, errors: any[] };
    if (resp.data.setDefaultOrderAllTiles.success == 'true') {
        dispatch(notificationSuccess(resp.data.setDefaultOrderAllTiles.message));
    } else {
        dispatch(notificationFail(resp.data.setDefaultOrderAllTiles.message));
    }
});